
import SubnavComponent          from "../Components/Subnav";
import CalendarComponent        from "../Components/Calendar";
import BoxComponent             from "../Components/Box";
import BoxQuadratic             from "../Components/BoxQuadratic";
import Slider                   from "../Components/Slider";
import Textpic                  from "../Components/Textpic";
import SearchBarComponent       from "../Components/SearchBar";
import MultiselectComponent     from "../Components/Multiselect";
import NavComponent             from "../Components/Nav";
import MenuListComponent        from "../Components/MenuList";
import TableComponent           from "../Components/Table";
import PersonTable              from "../Components/PersonTable";
import SidebarController        from "../Components/SidebarController";
import PlaceholderReplacer      from "../Components/PlaceholderReplacer";
import BlogArchiveSubnav        from "../Components/BlogArchiveSubnav";
import VirtualExhibitionSlider  from "../Components/VirtualExhibitionSlider";
import HideInputField           from "../Components/HideInputField";
import FormPrefillController    from "../Components/FormPrefillController";

import LayoutHelper             from "../Helper/Layout";
import BrowserHelper            from "../Helper/Browser";

import EventSystem              from "../Util/EventSystem";
import Logger                   from "../Util/Logger";


import moment from 'moment';

export default class App {
    // This class constant here toggles debug functionallity inside the app like extended logging
    static get DEBUG() {
        return true;
    }

    constructor(publicPath) {
        // ToDo: protect this variable somehow
        this.DEBUG = true;

        this._setDomFlags();

        try {
            App.instance = this;

            moment.locale('de');

            this._publicPath = publicPath;

            this._fetchBreakpoints();
            this._registerUtilityClasses();

            this._lastLayout    = LayoutHelper.getCurrentLayout();
            this._eventManager  = new EventSystem();
            this._logger        = new Logger( !this.DEBUG );

            this._registerPrivateEvents();

            this._components = {
                "box-quadratic":                new BoxQuadratic(),
                "box":                          new BoxComponent(),
                "nav":                          new NavComponent(),
                "subnav":                       new SubnavComponent("#blb-subnav"),
                "menulist":                     new MenuListComponent(),
                "calendar":                     new CalendarComponent(),
                "slider":                       new Slider(),
                "textpic":                      new Textpic(),
                "searchbar":                    new SearchBarComponent("form.blb-search-bar"),
                "multiselect":                  new MultiselectComponent(),
                "table":                        new TableComponent(),
                "personTable":                  new PersonTable(),
                "sidebarController":            new SidebarController(),
                "placeholder-replacer":         new PlaceholderReplacer(),
                "blog-archive-subnav":          new BlogArchiveSubnav(),
                "virtual-exhibition-slider":    new VirtualExhibitionSlider(),
                "hidden-input":                 new HideInputField(),
                "form-prefill-controller":      new FormPrefillController(),
            };
        } catch(e) {
            console.warn("Failed to construct app: ", e);
        } finally {

            // Make a call to all objects, in case some setup code needs the rest of the app._components array to be built already.
            _.mapObject(this._components, (val, key) => {
                if( typeof val._onAppComponentsLoaded == 'function' ) {
                    val._onAppComponentsLoaded();
                }
            });
        }

        // Tooltip objects may be moved by component code and the plugin doesn't like it, so we call it last
        this._registerTooltips();
    }

    getComponent(name) {
        return this._components[name];
    }

    getBreakpoints() {
        return this._breakpoints;
    }

    getEventManager() {
        return this._eventManager;
    }

    getLogger() {
        return this._logger;
    }

    getPublicPath() {
        return this._publicPath;
    }

    static getInstance() {
        if( !App.instance ) App.instance = new App();
        return App.instance;
    }

    _fetchBreakpoints() {
        let styles = require("sass-extract-loader!../../Sass/_variables.scss"); // This call is webpack specific

        this._breakpoints = _.mapObject( styles.global['$grid-breakpoints'].value, function (e) {
            return e.value;
        });
    }


    _registerUtilityClasses() {
        require("../Util/GlobalListeners");
    }

    _registerPrivateEvents() {
        $(window).on('resize', function(e) {
            let c = LayoutHelper.getCurrentLayout();

            if( this._lastLayout != c ) {
                this.getEventManager().emit('pageLayoutChange', {
                    'old': this._lastLayout,
                    'new': c
                });
                this._lastLayout = c;
            }
        }.bind(this));
    }

    _registerTooltips() {
      require("tooltipster");
      $('.blb-link > a[title]').not('a[title=""]').not('a[data-tooltip="false"]').tooltipster({
          side: ['left', 'right'],
          maxWidth: 305,
          distance: 25,
      });
      $('a[title]').not('a[title=""]').not('a[data-tooltip="false"]').not($(this).parent('.blb-link')).tooltipster({
          side: ['left', 'right'],
          maxWidth: 305
      });
      $('img[title]').not('img[title=""]').tooltipster({
          side: ['left', 'right'],
          maxWidth: 305,
      });
    }

    _setDomFlags() {
        // Is this the landing / root page?
        if( $('.blb-box-container-home').length > 0 ) {
            $('html').addClass("blb-landing");
        }

        // Check for IE
        if( BrowserHelper.isIE() ) {
            $('body').addClass('unsupported-browser');
        }

        // Are we in a mobile context?
        if( LayoutHelper.isMobile() ) {
            $('body').addClass('isMobile');
        }
    }
}
